import axios from 'axios'
import store from '@/store'
import { getToken, removeToken } from '@/utils/auth'
import { Toast, Dialog } from 'vant'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 30000
})
let loading
function startLoading() {
  loading = Toast.loading({
    message: '加载中...',
    forbidClick: true
  })
}

function endLoading() {
  loading.clear()
}
// request拦截器
service.interceptors.request.use(
  config => {
    if (!(config.url.includes('portal-sso') || config.url.includes('portal-user'))) {
      config.url = `/drSmfj${config.url}`
    }
    getToken() && (config.headers.Authorization = getToken())

    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json;charset=utf-8'
    if (config.isLoading === undefined) {
      startLoading()
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)
// 响应拦截器
service.interceptors.response.use(res => {
  endLoading()
  const code = res.data.code
  if (code === 70001 || code === 401) {
    Dialog.confirm({
      title: '系统提示',
      message: '登录状态已过期,请重新登录'
    }).then(() => {
      store.dispatch('LogOut')
      removeToken()
      location.href = '/pdamain/login'
    }).catch((err) => {
      console.log(err) // 非当前 vm
    })
  } else if (code !== 200) {
    Toast({
      message: res.data.msg,
      duration: 2500
    })
    // return Promise.resolve(res.data)
    return res.data
  } else {
    return res.data
  }
},
  (error) => {
    endLoading()
    console.log('err' + error)
    Toast({
      message: error.message,
      position: 'top'
    })
    // return Promise.resolve(error.response)
    return error.response
  }
)

export default service
